import React from 'react';
import Map from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// Get the Mapbox token from environment
const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';

interface PrintReportMapProps {
  latitude: number;
  longitude: number;
  zoom: number;
  children?: React.ReactNode;
  satellite?: boolean;
  interactive?: boolean;
}

const PrintReportMap: React.FC<PrintReportMapProps> = ({
  latitude,
  longitude,
  zoom,
  children,
  satellite = false,
  interactive = true
}) => {
  return (
    <Map
      initialViewState={{
        latitude,
        longitude,
        zoom,
      }}
      style={{ width: '100%', height: '100%' }}
      mapStyle={satellite 
        ? "mapbox://styles/mapbox/satellite-streets-v12" 
        : "mapbox://styles/mapbox/light-v11"
      }
      mapboxAccessToken={MAPBOX_TOKEN}
      attributionControl={false}
      interactive={interactive}
    >
      {children}
    </Map>
  );
};

export default PrintReportMap; 